// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
const UploadImageModal = require('client-v2/common/containers/upload-image-modal/component-dumb')
// Cousin imports
const collectionEditModalSelectors = require('../collection-edit-modal/selectors')
// Sibling imports
const actions = require('./actions')
const selectors = require('./selectors')

const headerText = 'Edit Collection banner image'
const imagePurpose = 'mix_header_image'
const imageRequirements = {
  minHeight: 384,
  minWidth: 2250,
  resizeHeight: 768,
  resizeWidth: 4500,
  maxFileSize: 10 * 1024 * 1024, // 10MB
  supportedFormats: ['JPEG', 'GIF', 'PNG'],
  supportedTypes: ['image/jpeg', 'image/gif', 'image/png']
}
const tips = selectors.tips(imageRequirements)

function mapStateToProps(state) {
  if (!selectors.isVisible(state)) {
    return { isVisible: false }
  }
  return {
    // Flags
    isPending: collectionEditModalSelectors.isPending(state),
    isVisible: true,
    // Values
    headerText,
    imagePurpose,
    tips,
    file: selectors.file(state),
    savedImageUrl: selectors.savedImageUrl(state),
    ...imageRequirements
  }
}

const mapDispatchToProps = {
  onDismiss: actions.hide,
  onDelete: actions.deleteImage,
  onPreviewError: actions.showPreviewError,
  onSubmit: actions.submitImage
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    UploadImageModal
  )
)
